const $$splitComponentImporter = () => import('/home/runner/work/upple-client-v2/upple-client-v2/src/routes/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/pages/$page.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';

// 공통 경로 상수 정의

// 프로그레스 바 애니메이션 스타일

// 라우트 정의
export const Route = createFileRoute('/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/pages/$page')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});

// 서베이 페이지 내용 컴포넌트
export function TSRDummyComponent() {
  return null;
}